import React, { ChangeEvent } from 'react';
import { styles } from './Checkbox.css';
interface CheckboxProps {
  id?: string;
  name?: string;
  isChecked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox = ({ isChecked, id, name, onChange }: CheckboxProps) => {
  return (
    <input type="checkbox" checked={isChecked} className={styles.checkBox} id={id} name={name} onChange={onChange} />
  );
};

export default Checkbox;
